import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export function useStoreData() {
  const [products, setProducts] = useState(null);
  const [settings, setSettings] = useState({ max_items: 4 });

  useEffect(() => {
    Promise.all([api.get("/products"), api.get("/settings")])
      .then(([p, s]) => {
        setProducts(p.data);
        setSettings(s.data);
      })
      .catch((e) => toast.error(errMsg(e)));
  }, []);

  return { products, settings };
}
